import { useEffect, useRef } from "react";
import { api } from "../lib/api";
import { useAuth } from "../lib/AuthContext";
import { useT } from "../lib/i18n";

export default function ProfileLanguageSync() {
  const { user, ready, refreshUser } = useAuth();
  const { lang, setLang } = useT();
  const applyingProfileLang = useRef(null);

  useEffect(() => {
    if (!ready || !user) return;
    const preferred = user.preferred_language;
    if ((preferred === "nl" || preferred === "en") && preferred !== lang) {
      applyingProfileLang.current = preferred;
      setLang(preferred);
    }
  }, [ready, user?.id, user?.preferred_language]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!ready || !user || (lang !== "nl" && lang !== "en")) return undefined;
    if (user.preferred_language === lang) {
      applyingProfileLang.current = null;
      return undefined;
    }
    // Bij eerste login/reload loopt effect-1 eerst (profiel → UI), maar effect-2
    // draait in diezelfde render nog met de oude localStorage-taal. Die mag dan
    // nooit terug naar de server schrijven; pas na de profielsync is de toggle
    // weer bidirectioneel.
    if (applyingProfileLang.current) {
      if (applyingProfileLang.current === lang) applyingProfileLang.current = null;
      return undefined;
    }
    let cancelled = false;
    api.put("/pt/me/language", { lang })
      .then(() => { if (!cancelled) refreshUser(); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [ready, user, lang, refreshUser]);

  return null;
}
